import React, { useRef } from "react";
import styled from "styled-components";

import { Cartesian } from "@examspark/types";

import {
  CartesianGraphContext,
  getRoundedCartesianCoordiate,
} from "./cartesian/utils";

const Styled = styled.div`
  user-select: none;
  display: flex;
  justify-content: center;
  svg {
    display: block;
  }
`;

const Wrapper = styled.div`
  background-color: #fff;
  border: solid 1px #ddd;
`;

export interface CartesianGraphProps extends Cartesian.Graph {}

/**
 * SVG element including wrapper styles and adjustments to ensure clean
 * renderings of cartesian graphs.
 */
const Graph: React.FC<React.PropsWithChildren<CartesianGraphProps>> = (
  props,
) => {
  const svgRef = useRef<SVGSVGElement>(null);

  return (
    <CartesianGraphContext.Provider
      value={{
        canvas: svgRef.current,
        graph: props,
        snapFn: getRoundedCartesianCoordiate,
      }}
    >
      <Styled>
        <Wrapper>
          <svg ref={svgRef} width={props.width} height={props.height}>
            <g transform="translate(0.5,0.5)">{props.children}</g>
          </svg>
        </Wrapper>
      </Styled>
    </CartesianGraphContext.Provider>
  );
};

export default Graph;
